import { useGetUserRolesForSchoolQuery } from '@schooly/api';
import { FC, PropsWithChildren } from 'react';

import { useSchool } from '../../hooks/useSchool';
import { UserRolesForSchoolContext } from './UserRolesForSchoolContext';

export const WithUserRolesForSchool: FC<PropsWithChildren> = ({ children }) => {
  const { schoolId = '' } = useSchool();

  const { data, isLoading, error, refetch } = useGetUserRolesForSchoolQuery(schoolId, {
    enabled: !!schoolId,
    refetchOnMount: 'always',
  });

  const value = {
    error: error ?? undefined,
    loadUserRoles: refetch,
    userRoles: data,
    isLoading,
  };

  return (
    <UserRolesForSchoolContext.Provider value={value}>
      {children}
    </UserRolesForSchoolContext.Provider>
  );
};
